import { createSelector } from "@reduxjs/toolkit";

//! id крайней созданной записи
export const selectLastAddedId = createSelector(
  [(state: any, modelName: string) => state.vpoStrapi.formAddActions[modelName]?.lastAddedId],
  (lastAddedId) => lastAddedId || null
);

//! id создателя крайней записи
export const selectLastAddedCreatorId = createSelector(
  [(state: any, modelName: string) => state.vpoStrapi.formAddActions[modelName]?.lastAddedCreatorId],
  (lastAddedCreatorId) => lastAddedCreatorId || null
);

//! Селектор для проверки, что именно указанный создатель создал последнюю запись
export const selectIsLastAddedByCreator = createSelector(
  [
    (state: any, modelName: string) => state.vpoStrapi.formAddActions[modelName]?.lastAddedId,
    (state: any, modelName: string) => state.vpoStrapi.formAddActions[modelName]?.lastAddedCreatorId,
    (state: any, modelName: string, creatorId: string) => creatorId
  ],
  (lastAddedId, lastAddedCreatorId, creatorId) => {
    return lastAddedId && lastAddedCreatorId === creatorId;
  }
);

//! Documentid крайней созданной записи
export const selectLastDocId = createSelector(
  [(state: any, modelName: string) => state.vpoStrapi.formAddActions[modelName]?.lastDocId],
  (lastDocId) => lastDocId || null
);

//! Несоответствия, загруженные для действия
export const selectInconsistenciesByAction = createSelector(
  [(state: any) => state.vpoStrapi.formAddActions['vpo-inconsistencies']?.data],
  (data) => data || []
);

//! Загрузка несоответствий
export const selectInconsistenciesLoading = createSelector(
  [(state: any) => state.vpoStrapi.formAddActions['vpo-inconsistencies']?.loading],
  (loading) => loading || false
);

//! Ошибка при загрузке несоответствий
export const selectInconsistenciesError = createSelector(
  [(state: any) => state.vpoStrapi.formAddActions['vpo-inconsistencies']?.error],
  (error) => error || null
);

